/**
 * Styles partagés pour les menus déroulants type "More actions" (ContextMenu).
 * Utilisés par ContextMenu, TableFilters (menu colonnes + config) et tout dropdown
 * qui doit avoir le même rendu (backdrop-blur, ombre, items h-9, hover primary).
 */

/** Conteneur du menu (à mettre dans un div déjà en position fixed) — fond semi-transparent, blur, bordure légère, ombre. Pour Select en variant context, ajouter w-full. */
export const DROPDOWN_MENU_PAPER =
  'min-w-[11rem] max-w-[18rem] w-max bg-white/95 dark:bg-white/90 backdrop-blur-md border border-gray-200/60 dark:border-gray-600/60 rounded-surface shadow-paper dark:shadow-paper-dark max-h-[70vh] overflow-y-auto overscroll-contain';

/** Une ligne d’item cliquable (hauteur 9, padding, hover) */
export const DROPDOWN_MENU_ITEM =
  'w-full text-left flex items-center gap-3 px-3.5 h-9 text-sm font-medium leading-snug min-w-0 transition-all duration-150 text-gray-700 dark:text-gray-200 hover:bg-primary-50 dark:hover:bg-primary-900/20 hover:text-primary-700 dark:hover:text-primary-300 active:bg-primary-100 dark:active:bg-primary-900/30';

/** Item désactivé */
export const DROPDOWN_MENU_ITEM_DISABLED =
  'text-gray-400 dark:text-gray-500 cursor-not-allowed pointer-events-none';

/** Item sélectionné (ex. option courante dans un select) */
export const DROPDOWN_MENU_ITEM_SELECTED =
  'bg-primary-50 dark:bg-primary-900/20 text-primary-700 dark:text-primary-300';

/**
 * Option idle dans un Select / liste d’options (padding géré à part).
 * Même hover brandé que DROPDOWN_MENU_ITEM.
 */
export const DROPDOWN_OPTION_IDLE =
  'text-gray-900 dark:text-gray-100 hover:bg-primary-50 dark:hover:bg-primary-900/20 hover:text-primary-700 dark:hover:text-primary-300';

/** Option sélectionnée dans un Select */
export const DROPDOWN_OPTION_SELECTED =
  'bg-primary-50 dark:bg-primary-900/20 text-primary-700 dark:text-primary-300';

/** Nom de l’animation d’entrée (à définir en CSS / style inline) */
export const DROPDOWN_MENU_ANIMATION = 'contextMenuFadeIn 150ms ease-out';

/** Keyframes pour les animations d'ouverture — source unique pour ContextMenu et Select. */
export const DROPDOWN_MENU_KEYFRAMES = `
  @keyframes contextMenuFadeIn {
    from { opacity: 0; transform: scale(0.95); }
    to { opacity: 1; transform: scale(1); }
  }
  @keyframes contextSubmenuSlideIn {
    from { opacity: 0; transform: translateX(-4px); }
    to { opacity: 1; transform: translateX(0); }
  }
`;
